import Vue from "vue";
import VueRouter from "vue-router";
import App from "./App.vue";

// LightBootstrap plugin
import LightBootstrap from "@/core/plugins/light-bootstrap-main";

// setup
import routes from "./core/routes/routes";
import store from "@/core/store";

// import 3rd party plugins
import "@/core/plugins/vuelidate";
import "@/core/plugins/bootstrap-vue";
import "@/core/plugins/fontawesome";
import "@/core/plugins/light-vue-tree";
import { i18n } from "@/core/plugins/i18n";

// plugin setup
Vue.use(VueRouter);
Vue.use(LightBootstrap);

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: "nav-item active",
  scrollBehavior: (to) => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
});

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
